import React from "react";
import "../../page_content.css";

const Sports = () => {
  const studentsData = [
    {
      name: "K GANESHWARA",
      games: "ATHLETICS",
      achievements: "WINNER"
    },
    {
      name: "AALIM M",
      games: "BOXING",
      achievements: "GOLD"
    },
    {
      name: "ZARA SHAIKH",
      games: "BOXING",
      achievements: "GOLD"
    },
    {
      name: "LAYA LR",
      games: "BOXING",
      achievements: "GOLD"
    },
    {
      name: "ANUSHKA BAGADE",
      games: "BOXING",
      achievements: "GOLD"
    },
    {
      name: "MALVIKA KURUP",
      games: "BOXING",
      achievements: "GOLD"
    },
    {
      name: "ANVITHA MANYA",
      games: "CROSS COUNTRY",
      achievements: "WINNER"
    },
    {
      name: "PRAJANA PRADHAN",
      games: "CROSS COUNTRY",
      achievements: "WINNER"
    },
    {
      name: "ANUSHKA PAWAR",
      games: "CROSS COUNTRY",
      achievements: "WINNER"
    },
    {
      name: "BHAKTI ASANE",
      games: "CROSS COUNTRY",
      achievements: "WINNER"
    },
    {
      name: "SHREEKA D R",
      games: "CROSS COUNTRY",
      achievements: "WINNER"
    },
    {
      name: "SPARSHA GOKHALE",
      games: "CROSS COUNTRY",
      achievements: "WINNER"
    },
    {
      name: "GAURAV KUMAR",
      games: "ROWING",
      achievements: "GOLD"
    },
    {
      name: "KARTIKEYAN SAWANT",
      games: "ROWING",
      achievements: "GOLD"
    }, {
      name: "PARAV VARAK",
      games: "ROWING",
      achievements: "GOLD"
    }, {
      name: "AYUSH JAISAWAL",
      games: "ROWING",
      achievements: "GOLD"
    }, {
      name: "VANSH PARIHAR",
      games: "ROWING",
      achievements: "GOLD"
    }, {
      name: "ROHIT SANJAY",
      games: "ROWING",
      achievements: "GOLD"
    }, {
      name: "VISHNU SATISH KUMAR",
      games: "ROWING",
      achievements: "GOLD"
    }, {
      name: "GAUTAM DHAMIJA",
      games: "ROWING",
      achievements: "GOLD"
    }, {
      name: "RAJGAURI KHARADE",
      games: "ROWING",
      achievements: "GOLD"
    },
    {
      name: "TANMAY DHANORKAR",
      games: "ROWING",
      achievements: "GOLD"
    },
    {
      name: "SAMIJA KORADE",
      games: "ROWING",
      achievements: "GOLD"
    },
    {
      name: "VINIT PAVASKAR",
      games: "SWIMMING",
      achievements: "WINNER"
    },
    {
      name: "JAY BAHUDHANIYA",
      games: "SWIMMING",
      achievements: "WINNER"
    },
    {
      name: "M V MANAV",
      games: "SWIMMING",
      achievements: "WINNER"
    }, {
      name: "VINIT PAVASKAR",
      games: "SWIMMING",
      achievements: "WINNER"
    }, {
      name: "DHRUV KOTIAN",
      games: "SWIMMING",
      achievements: "WINNER"
    }, {
      name: "ANVITHA MANYA",
      games: "KHO KHO",
      achievements: "WINNER"
    }, {
      name: "SHRADDHA SINGH YADAV",
      games: "KHO KHO",
      achievements: "WINNER"
    }, {
      name: "YASHI SRIVASTAVA",
      games: "KHO KHO",
      achievements: "WINNER"
    }, {
      name: "SURUCHI BHISE",
      games: "KHO KHO",
      achievements: "WINNER"
    }, {
      name: "VENI P P",
      games: "KHO KHO",
      achievements: "WINNER"
    },
    {
      name: "ANNTREESA MATHEW",
      games: "KHO KHO",
      achievements: "WINNER"
    },
    {
      name: "ANUSHKA P RAJEESH",
      games: "KHO KHO",
      achievements: "WINNER"
    },
    {
      name: "SAMRUDHI SHINDE",
      games: "KHO KHO",
      achievements: "WINNER"
    },
    {
      name: "VANSHIKA NAGAR",
      games: "KHO KHO",
      achievements: "WINNER"
    },
    {
      name: "ANUSHKA SHAKTI PAWAR",
      games: "KHO KHO",
      achievements: "WINNER"
    },
    {
      name: "ANJALI BANKAR",
      games: "KHO KHO",
      achievements: "WINNER"
    },
    {
      name: "MADIHAH S",
      games: "KHO KHO",
      achievements: "WINNER"
    },
    {
      name: "AISHWARYA LAXMI",
      games: "WATER POLO",
      achievements: "WINNER"
    },
    {
      name: "BHAIRAVI MEHENDALE",
      games: "WATER POLO",
      achievements: "WINNER"
    },
    {
      name: "SPARSHA GOKHALE",
      games: "WATER POLO",
      achievements: "WINNER"
    },
    {
      name: "ZARA SHAIKH",
      games: "WATER POLO",
      achievements: "WINNER"
    },
    {
      name: "ANSHIKA CHAVAN",
      games: "WATER POLO",
      achievements: "WINNER"
    },
    {
      name: "ANUSHKA BAGDE",
      games: "WATER POLO",
      achievements: "WINNER"
    },
    {
      name: "ANUSHKA PAWAR",
      games: "WATER POLO",
      achievements: "WINNER"
    },
    {
      name: "SHARWARI PAGAR",
      games: "WATER POLO",
      achievements: "WINNER"
    },
    {
      name: "YASHI SHRIWASTAVA",
      games: "WATER POLO",
      achievements: "WINNER"
    },
    {
      name: "DHRITI JAIN",
      games: "WATER POLO",
      achievements: "WINNER"
    },
    {
      name: "NAIVAILYA RAMESH",
      games: "WATER POLO",
      achievements: "WINNER"
    },
    {
      name: "UTKARSHA UMESH",
      games: "WATER POLO",
      achievements: "WINNER"
    },
    {
      name: "KUNAL BHANDARI",
      games: "VOLLEYBALL",
      achievements: "WINNER"
    },
    {
      name: "AVILVAZ",
      games: "VOLLEYBALL",
      achievements: "WINNER"
    },
    {
      name: "SHREYAS",
      games: "VOLLEYBALL",
      achievements: "WINNER"
    },
    {
      name: "AAYUSH GAWADE",
      games: "VOLLEYBALL",
      achievements: "WINNER"
    },
    {
      name: "MUHAMMAD KHAJE",
      games: "VOLLEYBALL",
      achievements: "WINNER"
    },
    {
      name: "UTKARSH JARIAL",
      games: "VOLLEYBALL",
      achievements: "WINNER"
    },
    {
      name: "AYUSH CHHETRI",
      games: "VOLLEYBALL",
      achievements: "WINNER"
    },
    {
      name: "ANFAL SHAIKH",
      games: "VOLLEYBALL",
      achievements: "WINNER"
    },
    {
      name: "SHREYAS K",
      games: "VOLLEYBALL",
      achievements: "WINNER"
    },
    {
      name: "AYSUH SHETTY",
      games: "VOLLEYBALL",
      achievements: "WINNER"
    },
    {
      name: "PREM SINGH",
      games: "VOLLEYBALL",
      achievements: "WINNER"
    },
    {
      name: "SWAR SHIRBHATE",
      games: "VOLLEYBALL",
      achievements: "WINNER"
    }
  ];

  return (
    <div>
      <h1 className="title">Sports</h1>
      <hr />

      <div className="page-content-container">
        <h2 className="innerpage-heading ">Inter Collegiate Competition 2025-26 Winner list</h2>

        <div className="table-responsive">
          <div className="table-responsive">
            <table className="page-content-table" style={{ width: "90%" }}>

              <thead>
                <tr>
                  <th>Sr. No.</th>
                  <th>Student Name</th>
                  <th>Department</th>
                  <th>Game Of Participation</th>
                  <th>Achievements</th>
                </tr>
              </thead>

              <tbody>
                {studentsData.map((student, index) => (
                  <tr key={index}>
                    {/* Auto Serial Number */}
                    <td>{index + 1}</td>
                    <td>{student.name}</td>
                    <td>MANET</td>

                    {/* Games */}
                    <td className="vertical-cell">
                      {(Array.isArray(student.games)
                        ? student.games
                        : [student.games]
                      ).map((game, i) => (
                        <div key={i}>{game}</div>
                      ))}
                    </td>

                    {/* Achievements */}
                    <td className="vertical-cell">
                      {(Array.isArray(student.achievements)
                        ? student.achievements
                        : [student.achievements]
                      ).map((ach, i) => (
                        <div key={i}>{ach}</div>
                      ))}
                    </td>
                  </tr>
                ))}
              </tbody>

            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sports;
